import React from 'react';
import { renderItemOrText } from '@utils/renderUtils.jsx';

export default function AnswerGrid({ options, selected, correct, revealed, onSelect, isSpectator, timeLeft }) {
    return (
        <div className="answers-grid">
            {options.map((opt, idx) => {
                const isSel = selected === opt;
                const isCor = revealed && correct === opt;
                const isWrong = revealed && selected === opt && correct !== opt;
                let className = 'answer-button';
                if (isSel) className += ' selected';
                if (isCor) className += ' correct';
                if (isWrong) className += ' wrong';
                return (
                    <button
                        key={idx}
                        onClick={() => onSelect(opt)}
                        disabled={revealed || timeLeft === 0 || isSpectator}
                        className={className}
                    >
                        <span className="answer-label">{'ABCD'[idx]}</span>
                        {opt.split(/\s*\+\s*/).map((part, i) => renderItemOrText(part.trim(), 24, i))}
                    </button>
                );
            })}
        </div>
    );
}